export default __webpack_public_path__ + "static/media/promo-banner.ab928514.png";